import { render, staticRenderFns } from "./CompanyIcon.vue?vue&type=template&id=fc0793c2&scoped=true"
import script from "./CompanyIcon.vue?vue&type=script&lang=ts"
export * from "./CompanyIcon.vue?vue&type=script&lang=ts"
import style0 from "./CompanyIcon.vue?vue&type=style&index=0&id=fc0793c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0793c2",
  null
  
)

export default component.exports